import {Injectable} from '@angular/core';
import {FeatureCopy, GenericResponse, Outs, Plans, Features} from '@ox/typings';
import {getFeaturesGroupByFeatureCatergoryCode as getFeaturesGroup} from '@ox/utils';
import {ShopDataService} from '../shop';


@Injectable()
export class FeatureManipulationService {

  constructor(
    private shopDataService: ShopDataService
  ) {}

  handleFeatureGroup(planCode: string, compareData?: Plans[], features?: Features[]): GenericResponse<Outs> {
    const product = this.shopDataService.getProductCopyByCode(planCode);
    // filter features if qualifying features are passed in
    if (product && product.features && features) {
      const codes = features.flatMap(f => f.codes.map((c: { code: string }) => c.code));
      product.features = product.features.filter(feature => codes.includes(feature.code));
    }
    const allProducts = this.shopDataService.getAllCopyProducts();
    /* We want to to make sure that we get a product and copy is giving data */
    if (product && allProducts) {
      const featuresFromCompare = compareData?.find((plan: Plans) => plan.code === product.code)?.features;
      return getFeaturesGroup(
        product,
        allProducts,
        featuresFromCompare as unknown as FeatureCopy[]
      ) as GenericResponse<Outs>;
    }
    return {};
  }

  /** Matches a plan's copy to only what the vehicle is qualified for based on VIN */
  getQualifiedFeatureCopy(planFeatureCopy: FeatureCopy[], qualifiedFeatures: Features): FeatureCopy[] {
    // only filter by category when a category is provided
    if (qualifiedFeatures.category)
      planFeatureCopy = planFeatureCopy.filter(feature => feature.featureCategoryCode === qualifiedFeatures.category);

    return planFeatureCopy.filter(feature => qualifiedFeatures.codes.map(code => code.code).includes(feature.code));
  }
}